<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="alterarProfissionalSolicitanteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Profissional Solicitante</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!marcacao" />

                        <div v-else>
                            <div class="alert alert-info">
                                <div class="lead">{{ marcacao.nome_paciente }}</div>
                                <div>#{{ marcacao.id_atendimento }}
                                    <span v-if="marcacao.st_id_externo">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ marcacao.st_id_externo }}
                                    </span>
                                </div>
                            </div>
                            <medico-solicitante
                                ref="medico_solic"
                                :block_executante="true"
                                v-model="marcacao.atendimento"
                                :validate="validate"
                                :required="marcacao.plano.id_operadora != 1"
                                :alter_proc="true"
                                :edicao="true" />

                            <template v-if="marcacao.atendimento.solicitante_outros">
                                <div class="mt-2" v-for="(medsol, isx) in marcacao.atendimento.solicitante_outros" :key="isx">
                                    <medico-solicitante
                                        :block_executante="true"
                                        v-show="!medsol.excluido"
                                        :can_remove="false"
                                        ref="medico_solic"
                                        v-model="marcacao.atendimento.solicitante_outros[isx]"
                                        :validate="validate"
                                        :required="true"
                                        :edicao="true" />
                                </div> 

                                <table class="table table-sm table-hover mt-3" v-if="solics">
                                    <thead>
                                        <tr>
                                            <th>Procedimento</th>
                                            <th class="text-center"><span v-if="marcacao.atendimento.medico_solicitante">{{ marcacao.atendimento.medico_solicitante.st_nome }}</span></th>
                                            <th v-for="(outro, iox) in marcacao.atendimento.solicitante_outros" :key="iox" class="text-center">
                                                <span v-if="outro.medico_solicitante">{{ outro.medico_solicitante.st_nome }}</span>
                                                <span v-else>?</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(atp, iax) in marcacao.atendimento.atendimento_procedimentos" :key="iax">
                                            <td>{{ atp.procedimento.search }}</td>
                                            <template v-if="solics && solics[iax]">
                                                <td v-for="(solic, isx) in solics[iax].solics" :key="isx">
                                                    <input type="checkbox" class="form form-control" v-model="solics[iax].solics[isx]">
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>

                                <br><br><br><br><br><br><br><br>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import MedicoSolicitante from '../../shared/MedicoSolicitante.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            lista: null, 
            marcacao: null,
            search: "",  
            guia: null, 
            validate: false, 
            solics: null, 
        }
    },

    components: { 
        AzEmptyState,
        AzSubmit, 
        MedicoSolicitante, 
    },

    computed: { 
        exibicao: function () { 
            if ( !this.lista )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.lista.filter (item => !this.search || reg.test(JSON.stringify(item)));
        }
    },

    methods: { 
        alterar_guia () { 

            /*

            this.search = "";
            this.lista = null;
            this.guia = guia;
            this.$store.commit('loading', true);

            $('#alterarProfissionalSolicitanteModal').modal('show');

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'lista_alterar_profissional',
                parms: { 
                    id_guia: guia.id_guia,
                }
            })
            .then(res => { 
                if ( !res ) { 
                    $('#alterarProfissionalModal').modal('hide');
                    return;
                }

                if ( !res.trocar ) { 
                    $('#alterarProfissionalModal').modal('hide');
                    return;
                } 

                this.lista = res.lista;
            })
            .finally(() => { 
               this.$store.commit('loading', false); 
            });

            */

        },

        alterar(marcacao) { 
            this.marcacao = null;
            this.validate = false;
            this.solics = null;
            
            $('#alterarProfissionalSolicitanteModal').modal('show');

            this.$util.load(this, { 
                service: 'marcacoes', 
                func: 'show',
                parms: {
                    id: marcacao.id_marcacao,
                },
                loadTo: res => {
                    this.marcacao = res;

                    if ( this.marcacao && this.marcacao.atendimento && this.marcacao.atendimento.solicitante_outros && this.marcacao.atendimento.solicitante_outros.length ) { 
                        this.solics = this.marcacao.atendimento.atendimento_procedimentos.map(atp => { 
                            let lista = { id_atendimento_procedimento: atp.id_atendimento_procedimento, solics: [] };

                            if ( _.get(atp.js_solics, this.marcacao.atendimento.id_medico_solicitante) ) { 
                                lista.solics.push(false);
                            } else { 
                                lista.solics.push(true);
                            }

                            this.marcacao.atendimento.solicitante_outros.forEach(outro => {
                                if ( _.get(atp.js_solics, outro.id_medico_solicitante) ) { 
                                    lista.solics.push(false);
                                } else { 
                                    lista.solics.push(true);
                                }   
                            });

                            return lista;

                        });
                    }

                }
            });
        },

        atualizar() { 

            /*
            if ( this.guia ) { 
                this.$util.atualizar(this, { 
                    service: 'guias',
                    func: 'alterar_profissional',
                    dados: { 
                        id_guia: this.guia.id_guia,
                        id_medico: medico.id_pessoa,
                    },
                    toast: true,
                    modal: 'alterarProfissionalModal',
                    callback: () => { 
                        this.$emit('refresh');
                    }
                });

                return;
            }
            */

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'alterar_solicitante',
                dados: { 
                    ...this.marcacao, 
                    solics: this.solics, 
                },
                toast: true,
                modal: 'alterarProfissionalSolicitanteModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
            
        }
    }

}
</script>